export function getAdressByZipCode(cep) {
  const request = fetch(`https://viacep.com.br/ws/${cep}/json/`)
    .then((result) => result.json())
    .then((data) => data);
  return request;
}
